"use strict";Object.defineProperty(exports, "__esModule", {value: true});





var _5OZ7J4C2cjs = require('./5OZ7J4C2.cjs');



var _OTCKJ4OKcjs = require('./OTCKJ4OK.cjs');



var _UCZW3OGHcjs = require('./UCZW3OGH.cjs');


var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/menu/menu-context.tsx
var _react = require('react');
var menu = _PTOCUU2Dcjs.createStoreContext.call(void 0, 
  [_UCZW3OGHcjs.CompositeContextProvider, _OTCKJ4OKcjs.HovercardContextProvider],
  [_UCZW3OGHcjs.CompositeScopedContextProvider, _OTCKJ4OKcjs.HovercardScopedContextProvider]
);
var useMenuContext = menu.useContext;
var useMenuScopedContext = menu.useScopedContext;
var useMenuProviderContext = menu.useProviderContext;
var MenuContextProvider = menu.ContextProvider;
var MenuScopedContextProvider = menu.ScopedContextProvider;
var useMenuBarContext = _5OZ7J4C2cjs.useMenubarContext;
var useMenuBarScopedContext = _5OZ7J4C2cjs.useMenubarScopedContext;
var useMenuBarProviderContext = _5OZ7J4C2cjs.useMenubarProviderContext;
var MenuBarContextProvider = _5OZ7J4C2cjs.MenubarContextProvider;
var MenuBarScopedContextProvider = _5OZ7J4C2cjs.MenubarScopedContextProvider;
var MenuItemCheckedContext = _react.createContext.call(void 0, 
  void 0
);













exports.useMenuContext = useMenuContext; exports.useMenuScopedContext = useMenuScopedContext; exports.useMenuProviderContext = useMenuProviderContext; exports.MenuContextProvider = MenuContextProvider; exports.MenuScopedContextProvider = MenuScopedContextProvider; exports.useMenuBarContext = useMenuBarContext; exports.useMenuBarScopedContext = useMenuBarScopedContext; exports.useMenuBarProviderContext = useMenuBarProviderContext; exports.MenuBarContextProvider = MenuBarContextProvider; exports.MenuBarScopedContextProvider = MenuBarScopedContextProvider; exports.MenuItemCheckedContext = MenuItemCheckedContext;
